import React, { Fragment, useRef, useState } from "react";
import PinField from "react-pin-field";
import bcrypt from "bcryptjs";

import { Transition } from "@headlessui/react";

const GeneratePin = ({ formData, setFormData }) => {
	const pinRef = useRef(null);
	const confirmPinRef = useRef(null);

	const [newPin, setNewPin] = useState(null);
	const [isCorrectPin, setIsCorrectPin] = useState(null);

	const registerUser = (e) => {
		if (e !== newPin) {
			setIsCorrectPin("invalid");

			confirmPinRef.current.forEach((input) => (input.value = ""));
			confirmPinRef.current[0].focus();
		} else {
			const hashedPin = bcrypt.hashSync(newPin, 12);

			setFormData({
				...formData,
				password: hashedPin,
			});
		}
	};

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
			leave="transition-opacity duration-250"
			leaveFrom="opacity-100"
			leaveTo="opacity-0"
		>
			<div className="flex flex-col items-center justify-center space-y-8">
				<div className="flex flex-col items-center justify-center space-y-2">
					<p className="text-center text-sm text-dark-blue">
						Set a 4-digit PIN to prevent unauthorized access to your Daffi
						<span className="italic">Wallet</span>
					</p>
					<div className="flex w-full items-center justify-center space-x-3">
						<PinField
							className={`text-center border border-dark-blue outline-none smooth text-5xl pb-2 rounded-full text-dark-blue h-14 w-14 focus:border-2 invalid:animate-[bounce_75ms_linear_2]`}
							onComplete={(e) => {
								setNewPin(e);
								confirmPinRef.current[0].focus();
							}}
							onChange={() => setIsCorrectPin(null)}
							length={4}
							ref={pinRef}
							validate="0123456789"
							type="password"
							autoFocus
							disabled={false}
						/>
					</div>
				</div>
				<div className="flex flex-col items-center justify-center space-y-2">
					<p className="text-sm text-dark-blue">Re-enter your selected pin</p>

					<div
						className={`flex w-full items-center justify-center space-x-3 ${
							isCorrectPin === "invalid" && "animate-[bounce_75ms_linear_2]"
						}`}
					>
						<PinField
							className={`text-center border border-dark-blue outline-none smooth text-5xl pb-2 rounded-full text-dark-blue h-14 w-14 focus:border-2 invalid:animate-[bounce_75ms_linear_2]`}
							onComplete={(e) => registerUser(e)}
							onChange={() => setIsCorrectPin(null)}
							ref={confirmPinRef}
							length={4}
							validate="0123456789"
							type="password"
							disabled={false}
						/>
					</div>
				</div>
				{isCorrectPin === "invalid" && (
					<p className={`text-center text-sm text-candy-red`}>
						Please try again, the PINs you entered are not identical
					</p>
				)}
			</div>
		</Transition>
	);
};

export default GeneratePin;
